export const ToolboxIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2022_34609)">
        <path
          d="M17.5 5.625H2.5C2.15482 5.625 1.875 5.90482 1.875 6.25V15C1.875 15.3452 2.15482 15.625 2.5 15.625H17.5C17.8452 15.625 18.125 15.3452 18.125 15V6.25C18.125 5.90482 17.8452 5.625 17.5 5.625Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.875 9.375H18.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 8.125V10.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.375 8.125V10.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.125 5.625V4.375C13.125 4.04348 12.9933 3.72554 12.7589 3.49112C12.5245 3.2567 12.2065 3.125 11.875 3.125H8.125C7.79348 3.125 7.47554 3.2567 7.24112 3.49112C7.0067 3.72554 6.875 4.04348 6.875 4.375V5.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2022_34609">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
